<template>
    <print-config-layout class="print-config-evaluation">
        <template #icon>
            <component :is="iconComponent" class="print-config-icon--extra-small"/>
        </template>
        <template #text>
            <p>
                <span>{{config.question}}</span>
                <span v-if="attachmentUrls.length"><br>{{$t('pages.print.risk-assessment.attached-files')}}:
                    <template v-for="url in attachmentUrls">
                        <span class="print-config-evaluation__attachment">
                                {{getFileName(url)}}
                        <span class="comma">, </span>
                        </span>
                    </template>
                </span>
                <span v-if="templates.length"><br>{{$t('pages.print.risk-assessment.templates')}}:
                    <template v-for="template in templates">
                        <span class="print-config-evaluation__template">
                            {{template.title}}
                        <span class="comma">, </span>
                        </span>
                    </template>
                </span>
            </p>
        </template>
        <template #answer>
            <e-evaluation-circle
                    :answer="answers.answer"
            />
        </template>
    </print-config-layout>
</template>

<script>
    import printConfigLayout from "@pages/print/concrete/print-config-layout"
    import eEvaluationCircle from '@elements/print/e-evaluation-circle'
    import effectiveness from "@mixins/helpers/_effectiveness";

    export default {
        name: "print-config-evaluation",
        mixins: [effectiveness],
        components: {
            eEvaluationCircle,
            printConfigLayout
        },
        props: {
            config: {
                type: Object
            },
            answers: {
                type: Object
            },
            level: {
                type: Number
            }
        },
        computed: {
            iconComponent() {
                return this.effectivenessHelper.answerIcon(this.answers.answer)
            },
            attachmentUrls() {
                //remove attachments without valid url
                let mappedArr = this.config.attachments.map(el => el.url);
                return mappedArr.filter(el => el !== null)
            },
            templates() {
                return this.config.templates
            }
        },
        methods: {
            getFileName(url) {
                return url.split('/').pop();
            }
        }
    }
</script>

<style lang="scss">
    .print-config-evaluation {
        padding-bottom: .5rem;
        margin-bottom: 1.5rem;
        position: relative;

        &::after {
            content: '';
            position: absolute;
            width: 95%;
            bottom: 0;
            right: 0;
            height: 2px;
            background: var(--v-secondary-darken1);
        }

        &__attachment,
        &__template{
            &:last-of-type > .comma {
                display: none
            }
        }
    }
</style>